import { useContext, useEffect } from "react"
import { AuthContext } from "context/AuthContext"
import { LoadingScreen } from "components/LoadingScreen"
import { motion } from "framer-motion"
import { useErrorModal } from "context/ErrorContext"
import { ClientContext } from "context/ClientContext"
import { buildAuthRedirectUrl } from "utilities"

export const LogoutPage = () => {
  const { unsetTokens } = useContext(AuthContext)
  const { clearError } = useErrorModal()

  const { client } = useContext(ClientContext)

  useEffect(() => {
    unsetTokens()
    clearError()

    // Redirect to ADB2C sign-in page
    if (client?.adb2cUrl && client?.redirectUrl) {
      const signInUrl = buildAuthRedirectUrl({
        authServiceUrl: client.adb2cUrl,
        callbackUrl: client.redirectUrl
      })
      window.location.href = signInUrl
    }
  }, [unsetTokens, clearError, client])

  return (
    <LoadingScreen
      data-testid="logout-page_loading-screen"
      height="full"
      as={motion.div}
      initial={{ opacity: 0.5 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.5 }}
    />
  )
}
